'use client';

import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
import React, { useMemo } from 'react';
import Observability from '@launchdarkly/observability';
import SessionReplay from '@launchdarkly/session-replay';
import { LDProvider } from 'launchdarkly-react-client-sdk';
import type { Session } from 'next-auth';
import { MembershipType } from '@/lib/entitlements/membership-type';
const defaultLdContext = {
  kind: 'user',
  key: 'anonymous',
  anonymous: true
};
const sessionReplayPlugins = [new Observability({
  tracingOrigins: true,
  networkRecording: {
    enabled: true,
    recordHeadersAndBody: true
  }
}), new SessionReplay({
  privacySetting: 'none',
  inlineStylesheet: true,
  inlineImages: true
})];
export default function ClientLaunchdarklyProvider(t0) {
  const $ = _c(11);
  const {
    children,
    user,
    sessionReplayEnabled
  } = t0;
  let t1;
  let t2;
  if ($[0] !== user) {
    t2 = user ? {
      kind: "user",
      key: user.sub,
      custom: {
        isGAUser: user.membershipTypes.includes(MembershipType.GROUP),
        isMemcoUser: user.membershipTypes.includes(MembershipType.MEMCO)
      }
    } : defaultLdContext;
    $[0] = user;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  t1 = t2;
  const context = t1;
  let t3;
  let t4;
  if ($[2] !== sessionReplayEnabled) {
    t4 = sessionReplayEnabled ? sessionReplayPlugins : [];
    $[2] = sessionReplayEnabled;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      debug: _temp,
      info: _temp2,
      warn: _temp3,
      error: _temp4
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4) {
    t6 = {
      plugins: t4,
      logger: t5
    };
    $[5] = t4;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  t3 = t6;
  const options = t3;
  let t7;
  if ($[7] !== children || $[8] !== context || $[9] !== options) {
    t7 = <LDProvider clientSideID={process.env.NEXT_PUBLIC_LAUNCH_DARKLY_CLIENT_SIDE_ID || ""} context={context} options={options} timeout={5}>{children}</LDProvider>;
    $[7] = children;
    $[8] = context;
    $[9] = options;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}
function _temp4() {}
function _temp3() {}
function _temp2() {}
function _temp() {}